import { render, staticRenderFns } from "./StagingEditorHeaderDocInfo.vue?vue&type=template&id=2a7d0ec8"
import script from "./StagingEditorHeaderDocInfo.vue?vue&type=script&lang=ts"
export * from "./StagingEditorHeaderDocInfo.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorHeaderDocInfo.vue?vue&type=style&index=0&id=2a7d0ec8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports